<script setup lang="ts">
defineProps<{
  data: BigHeadingWithMediaProps
  chapterIndex?: number
  sectionIndex: number
  template?: 'page' | 'overlay'
}>()
</script>

<template>
  <section
    class="relative grid h-[110vh]"
    :class="{
      'bg-white': template !== 'page' && template !== 'overlay' && data.theme !== 'light-grey',
      'bg-light-grey':
        template === 'page' || (template !== 'overlay' && data.theme === 'light-grey'),
    }"
  >
    <div
      class="relative z-1 col-start-1 row-start-1 flex w-full flex-col items-center justify-center pt-32 pb-6 lg:pt-47 lg:pb-69"
      :class="{
        'pb-32 lg:pb-69': !data.overlays,
      }"
      :style="{
        color: data.media?.video
          ? 'var(--color-white)'
          : data.media?.image?.palette?.dominant?.foreground,
      }"
    >
      <ElementsChapter
        v-if="chapterIndex && data.trumpet"
        class="pb-6 text-center lg:pb-8"
        :chapter="data.trumpet"
        :index="chapterIndex"
      />
      <ElementsTitleRevealv2
        :title="data.text"
        class="font-display mx-auto max-w-[10em] text-center text-5xl uppercase font-stretch-expanded lg:max-w-[8em] lg:text-7xl"
      />
    </div>

    <CommonMedia
      :sizes="'80vw'"
      :fill="'both'"
      class="col-start-1 row-start-1 row-end-3 w-screen"
      :media="data.media"
      :loading="sectionIndex === 0 ? 'eager' : 'lazy'"
    />

    <div
      class="pointer-events-none relative bottom-0 z-2 ml-auto flex h-full items-end max-lg:col-start-1 max-lg:row-start-2 lg:absolute lg:right-0 lg:w-1/2"
    >
      <div class="bottom-0 flex flex-col lg:sticky lg:ml-auto lg:w-1/2">
        <ElementsOverlayButton
          v-for="(overlay, index) in data.overlays"
          :key="index"
          :overlay="overlay"
          class="lg:w-full"
        />
      </div>
    </div>
  </section>
</template>
